module.exports = __webpack_public_path__ + "static/media/IMG_8773.9edca2d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/vertical/IMG_8773.jpg
// module id = 114
// module chunks = 0